import React from 'react'
import injectSheet from 'react-jss'
import styles from './password.styles'
import Section from '../../../shared/section/section'
import Segment from '../../../shared/segment/segment'
import Segments from '../../../shared/segments/segments'
import Description from '../../../shared/description/description'
import Label from '../../../shared/label/label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Button from 'pobble-components/dist/button'
import classNames from 'classnames'
import { Formik } from 'formik'
import * as Yup from 'yup'

const Password = ({
  classes,
  pending,
  firstName,
  lastName,
  displayName,
  email,
  onSubmit
}) => (
  <Formik
    onSubmit={onSubmit}
    initialValues={{
      email: '',
      currentPassword: '',
      password: '',
      repeatPassword: ''
    }}
    validationSchema={Yup.object().shape({
      currentPassword: Yup.string().required(
        'Please provide your current password'
      ),
      password: Yup.string()
        .required('Please provide your password')
        .min(9, 'Minimum password length is 9 characters')
        .matches(
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]).{9,64}$/,
          {
            message:
              'Password should contain at least one uppercase, one lowercase, one number and one special character'
          }
        ),
      repeatPassword: Yup.string()
        .required('Please confirm your password')
        .oneOf([Yup.ref('password'), null], 'Passwords do not match')
    })}>
    {formikProps => {
      const {
        values,
        handleBlur,
        handleChange,
        handleSubmit,
        isValid,
        touched,
        errors
      } = formikProps
      return (
        <form
          onSubmit={handleSubmit}
          className={classNames(classes.form, { [classes.pending]: pending })}>
          <Section
            title="Manage passwords"
            pending={pending}
            renderHeader={() => (
              <Button
                className={classes.submitButton}
                disabled={!isValid}
                type="submit"
                tall>
                Save changes
              </Button>
            )}>
            <Segments>
              <Segment size={'M'}>
                <Label htmlFor={'currentPassword'}>Current password</Label>
                <FormInput
                  name="currentPassword"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.currentPassword}
                  placeholder={'Your current password'}
                  type="password"
                  autoComplete="current-password"
                  validationError={
                    touched.currentPassword && errors.currentPassword
                  }
                />
              </Segment>
            </Segments>
            <Segments>
              <Segment>
                <Label htmlFor={'password'}>New password</Label>
                <FormInput
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  placeholder={'Your new password'}
                  type="password"
                  autoComplete="new-password"
                  validationError={touched.password && errors.password}
                />
              </Segment>
              <Segment>
                <Label htmlFor={'repeatPassword'}>
                  New password confirmation
                </Label>
                <FormInput
                  name="repeatPassword"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.repeatPassword}
                  placeholder={'Once again'}
                  type="password"
                  autoComplete="new-password"
                  validationError={
                    touched.repeatPassword && errors.repeatPassword
                  }
                />
              </Segment>
              <Segment>
                <Description>
                  Your password must be at least 9 characters, and should
                  contain at least one uppercase, one lowercase, one number and
                  one special character.
                </Description>
              </Segment>
            </Segments>
          </Section>
        </form>
      )
    }}
  </Formik>
)

export default injectSheet(styles)(Password)
